import Vue from 'vue'
import VueRouter from 'vue-router'

import filter from '../js/services/filter';

Vue.use(VueRouter);

const router = new VueRouter({
    mode: 'history',

    scrollBehavior(to, from, savedPosition) {
        return {x: 0, y: 0}
    },

    routes: [

        /* *** PAGES *** */
        {
            path: '/',
            component: require('./pages/views/Index').default,
            name: 'pages-index',
        },

        {
            path: '/sitemap',
            component: require('./pages/views/sitemap/Index').default,
            name: 'pages-sitemap',
        },

        {
            path: '/delivery',
            component: require('./pages/views/info/Delivery').default,
            name: 'pages-delivery',
        },

        {
            path: '/about',
            component: require('./pages/views/info/About').default,
            name: 'pages-about',
        },

        /* RULES */
        {
            path: '/rules',
            component: require('./pages/views/rules/Index').default,
            name: 'pages-rules',
        },
        {
            path: '/rules/:slug',
            component: require('./pages/views/rules/Show').default,
            name: 'pages-rules-show',
        },

        /* SERVICES */
        {
            path: '/services',
            component: require('./pages/views/services/Index').default,
            name: 'pages-services',
        },
        {
            path: '/services/:slug',
            component: require('./pages/views/services/Show').default,
            name: 'pages-services-show',
        },

        /* NEWS */
        {
            path: '/news',
            component: require('./pages/views/news/Index').default,
            name: 'pages-news',

        },
        {
            path: '/news/:slug',
            component: require('./pages/views/news/Show').default,
            name: 'pages-news-show',
        },
        /* PHOTOSTUDIOS */
        {
            path: '/photostudios',
            component: require('./pages/views/photostudios/Index').default,
            name: 'pages-photo-studios',
        },
        {
            path: '/photostudios/:slug',
            component: require('./pages/views/photostudios/Show').default,
            name: 'pages-photo-studios-show',
        },

        /* SHARES */
        {
            path: '/promotions',
            component: require('./pages/views/shares/Index').default,
            name: 'pages-shares',
        },
        {
            path: '/promotions/:slug',
            component: require('./pages/views/shares/Show').default,
            name: 'pages-shares-show',
        },

        /* PROJECTS */
        {
            path: '/projects',
            component: require('./pages/views/projects/Index').default,
            name: 'pages-projects',
        },
        {
            path: '/projects/tv',
            component: require('./pages/views/projects/Tv').default,
            name: 'pages-projects-tv',
        },
        {
            path: '/projects/support',
            component: require('./pages/views/projects/Support').default,
            name: 'pages-projects-support',
        },
        {
            path: '/projects/application',
            component: require('./pages/views/projects/Application').default,
            name: 'pages-projects-application',
        },
        {
            path: '/projects/:slug',
            component: require('./pages/views/projects/Show').default,
            name: 'pages-projects-show',
        },



        /* CONTACTS */
        {
            path: '/contact',
            component: require('./pages/views/info/Contacts').default,
            name: 'pages-contacts',
        },

        /* LOGIN / REGISTER */
        {
            path: '/login',
            component: require('./pages/views/auth/Login').default,
            name: 'pages-login',
        },
        {
            path: '/register',
            component: require('./pages/views/auth/Register').default,
            name: 'pages-register',
        },
        {
            path: '/reset',
            component: require('./pages/views/auth/Reset').default,
            name: 'pages-reset',
        },

        /* BASKET */
        {
            path: '/basket',
            component: require('./pages/views/basket/Index').default,
            name: 'pages-basket',
        },

        /* CATALOG */
        {
            path: '/catalog',
            component: require('./pages/views/catalog/Index').default,
            name: 'pages-catalog',
        },
        {
            path: '/catalog/new',
            component: require('./pages/views/catalog/Index').default,
            name: 'pages-catalog-new',
        },
        {
            path: '/catalog/category/:category',
            component: require('./pages/views/catalog/Index').default,
            name: 'pages-catalog-category',
        },
        {
            path: '/catalog/category/:category/*',
            component: require('./pages/views/catalog/Index').default,
            name: 'pages-catalog-category-subcategory',
        },
        {
            path: '/catalog/product/:id',
            component: require('./pages/views/catalog/Show').default,
            name: 'pages-catalog-show',
        },
        {
            path: '/sale',
            component: require('./pages/views/sale/Index').default,
            name: 'pages-sale',
        },
        {
            path: '/sale/product/:id',
            component: require('./pages/views/sale/Show').default,
            name: 'pages-sale-show',
        },
        {
            path: '/discount',
            component: require('./pages/views/discount/Index').default,
            name: 'pages-discount',
        },
        {
            path: '/search',
            component: require('./pages/views/search/Index').default,
            name: 'pages-search',
        },

        {
            path: '/test-booking',
            component: require('./pages/views/booking/Index').default,
            name: 'pages-search',
        },

        /* *** ACCOUNT *** */
        {
            path: '/account',
            component: require('./pages/views/account/Index').default,
            name: 'account-index',
            meta: {
                title: 'Личный кабинет | Фотопрокат "MRental"',
                requiresAuth: true
            },
        },
        {
            path: '/account/personal',
            component: require('./pages/views/account/Index').default,
            name: 'account-personal',
            meta: {
                title: 'Личная информация | Фотопрокат "MRental"',
                requiresAuth: true
            },
        },
        {
            path: '/account/ref_link',
            component: require('./pages/views/account/Index').default,
            name: 'account-ref',
            meta: {
                title: 'Реферальная ссылка| Фотопрокат "MRental"',
                requiresAuth: true
            },
        },
        {
            path: '/account/orders',
            component: require('./pages/views/account/Index').default,
            name: 'account-orders',
            meta: {
                title: 'История заказов | Фотопрокат "MRental"',
                requiresAuth: true
            },
        },
        {
            path: '/account/card',
            component: require('./pages/views/account/Index').default,
            name: 'account-card',
            meta: {
                title: 'Карта клиента | Фотопрокат "MRental"',
                requiresAuth: true
            },
        },
        {
            path: '/account/discount',
            component: require('./pages/views/account/Index').default,
            name: 'account-discount',
            meta: {
                title: 'Новая дисконтная программа | Фотопрокат "MRental"',
                requiresAuth: true
            },
        },
        {
            path: '/account/new_orders',
            component: require('./pages/views/account/Index').default,
            name: 'account-new',
            meta: {
                title: 'Новые заказы | Фотопрокат "MRental"',
                requiresAuth: true
            },
        },



        {
            path: '/basket/thank-you-page',
            component: require('./pages/views/basket/Thanks').default,
            name: 'basket-thank',
            meta: {
                title: 'Оформление заказа | Фотопрокат "MRental"',
                requiresAuth: true
            },
        },

        /*404*/
        {
            path: "/404",
            component: require('./pages/views/error/404').default,
        },
        {
            path: "*",
            component: require('./pages/views/error/404').default,
        }


    ]
});

router.beforeEach((to, from, next) => {
    /*check prev page (use for mobile catalog) */
    if (window.innerWidth < 1200) {
        if(from.name === 'pages-catalog-show') filter.state.prev_item = true;
        else filter.state.prev_item = false;
    }
    else filter.state.prev_item = false;

    /*redirect to account from login or register */
    if ((to.name === 'pages-login' || to.name === 'pages-register') && localStorage.getItem('token')) {
        window.location.pathname = "/account";
    }
    else next();

    /*check login*/
    if (to.matched.some(record => record.meta.requiresAuth)) {
        if (!localStorage.getItem('token')) {
            window.location.pathname = "/login";
        } else {
            next();
        }
    } else {
        next();
    }

    if (to.name !== 'pages-mystudio') {
        let aeWidgetBtn = document.getElementsByClassName('aeWidgetBtn');
        if (aeWidgetBtn != null && aeWidgetBtn.length > 0) {
            aeWidgetBtn[0].setAttribute('style', 'display: none !important;');
        }
    }
    document.querySelector('meta[name="robots"]').setAttribute("content",  '');
});


export default router;
